module.exports = __webpack_public_path__ + "static/img/img29.5a6f67f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img29.jpg
// module id = HLOE
// module chunks = 1